// extracted by mini-css-extract-plugin
module.exports = {"root":"DripEdge_root__AjLe_"};